/**
 * @desc 通过ID获取费用映射信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.CostItemMappingResponseDto>;
export function request(
  params: API.basics.costItemMappingFacadeimpl.getCostItemMappingInfoById.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costItemMapping/getCostItemMappingInfoById`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
